var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f9ed9690-6753-43a7-8b32-d66ac7b8a99a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f710a364-083f-494c-9d96-89b92ee2d5a8",
    x1: 0.5,
    y1: 9.77,
    x2: 9,
    y2: 9.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0074cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#006abb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005ba1"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-databases-126") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.25,10.48V6.57a.14.14,0,0,0-.24-.1l-4,4L4.85,14.63V17.5H16.93a.56.56,0,0,0,.57-.57V6.57a.14.14,0,0,0-.24-.1Z",
    fill: "#005ba1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,3.58C2.4,3.58.5,2.89.5,2V7.67h0v9.26a.56.56,0,0,0,.57.57H9V2C9,2.89,7.1,3.58,4.75,3.58Z",
    fill: "url(#f710a364-083f-494c-9d96-89b92ee2d5a8)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 12.97,
    width: 2.27,
    height: 2.27,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.97,
    y: 12.97,
    width: 2.27,
    height: 2.27,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.03,
    y: 12.97,
    width: 2.27,
    height: 2.27,
    rx: 0.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,2c0,.85-1.9,1.54-4.25,1.54S.5,2.89.5,2,2.4.5,4.75.5,9,1.19,9,2",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1.91c0,.55-1.46,1-3.26,1s-3.26-.43-3.26-1S3,.94,4.75.94,8,1.37,8,1.91",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,2.14a8.07,8.07,0,0,0-2.58.37,7.64,7.64,0,0,0,2.58.38,7.64,7.64,0,0,0,2.58-.38A8.07,8.07,0,0,0,4.75,2.14Z",
    fill: "#198ab3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdf);
export default __webpack_public_path__ + "static/media/ADF.0ab24811debf6f8616208e4d7fbc6f40.svg";
export { ForwardRef as ReactComponent };